import React from 'react';
import { Skeleton as AntSkeleton } from 'antd';
import styled from 'styled-components';

const Skeleton = styled(AntSkeleton)`
  .ant-skeleton-paragraph {
    padding-left: 0;
    opacity: 0.2;
  }

  .ant-skeleton-title {
    padding-left: 0;
    opacity: 0.2;
  }
`;

export default Skeleton;
